import React from "react";
import "../static/style/badge.css";

export default props => {
  return (
    <span className={"badge badge-pill " + props.badgeColor}>{props.text}</span>
  );
};



// WEBPACK FOOTER //
// ./src/components/Badge.js